/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-25 10:37:45
 */

import Api from 'src/util/api';
import { PageDo, Result, ResultPageDo, Integer } from 'src/types/base';
import { defaultNullValue } from 'src/config';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
export declare namespace CompareExceptionDOI {
    export interface RowDataI {
        abnormity_site: any;
        dispose_company: string;
        id: number;
        inform_number: string;
        initiator: string;
        sponsor_datetime: string;
        status: number;
    }

    export interface QueryRowDataParamsI extends PageDo {
        keyword?: string;
        end_time?: Integer;
        start_time?: Integer;
        status?: Integer;
    }

    export interface QueryDetailResultI {
        abnormity_site: {
            data: {
                dispose_condition: number;
                dispose_datatime: string;
                dispose_explain: string;
                dispose_people: string
                dispose_people_id: number;
                dispose_site: string
                operational_content: string
                operational_equipment: string[];
                operational_site: string
                operational_id: number
                ops_leader_status:number
                task_number: string
            }[];
        };
        dispose_company: string
        dispose_company_id: number
        inform_number: string
        initiator: string
        sponsor_datetime: string
    }

    export interface OperateParamsI {
        id?: Integer;
        abnormity_site: any;
        dispose_company_id: Integer;
    }
}
export default class CompareExceptionApi {
    /**
     * 查询列表
     * @param {CompareExceptionDOI.QueryRowDataParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: CompareExceptionDOI.QueryRowDataParamsI): Promise<ResultPageDo<CompareExceptionDOI.RowDataI[]>> {
        return Api.post('/ops/abnormity_infrom/list/get', {
            status: defaultNullValue,
            keyword: '',
            end_time: DateTimeUtil.getSecondFromIviewDate(new Date()),
            start_time: DateTimeUtil.getSecondFromIviewDate(new Date('1990')),
            ...params,
        });
    }
    /**
     * 查询列表
     * @param {{id: number}} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchDetail(params: { id: number }): Promise<Result<CompareExceptionDOI.QueryDetailResultI>> {
        return Api.post('/ops/abnormity_infrom/particulars/get', params);
    }
    /**
     * 新增
     * @param {CompareExceptionDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async add(data: CompareExceptionDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/abnormity_infrom/add', data);
    }

    /**
     * 修改
     * @param {CompareExceptionDOI.OperateParamsI} data
     * @returns {Promise<Result<any>>}
     */
    static async update(data: CompareExceptionDOI.OperateParamsI): Promise<Result<any>> {
        return Api.post('/ops/abnormity_infrom/edit', data);
    }

    /**
     * 删除
     * @param {Array<number>} data
     * @returns {Promise<Result<any>>}
     */
    static async delete(data: { ids: Array<number> }): Promise<Result<any>> {
        return Api.post('/ops/abnormity_infrom/batch/delete', data);
    }
}
